import { memo } from 'react';
import { CheckIcon } from 'src/themes/cosmos/icons';
import { IPlaybackRateOption } from 'src/interfaces/PlaybackRate';
import SettingOption from '../SettingOption';

export interface IPlaybackRateOptionProps {
  onChange: (rate: number) => void;
  rateSelected: number;
  playbackRateOptions: IPlaybackRateOption[];
}

const PlaybackRateControl = ({ playbackRateOptions, rateSelected, onChange }: IPlaybackRateOptionProps) => {
  return (
    <>
      {playbackRateOptions.map(({ label, rate }) => {
        const isActive = rate === rateSelected;
        return (
          <SettingOption
            key={label}
            aria-label={`playback rate option ${label}`}
            active={isActive}
            rightIcon={isActive && <CheckIcon />}
            onClick={() => onChange(rate)}
          >
            {label}
          </SettingOption>
        );
      })}
    </>
  );
};

export default memo(PlaybackRateControl);
